var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('g-signin-button',{attrs:{"params":_vm.googleSignInParams},on:{"success":_vm.onSignInSuccess,"error":_vm.onSignInError}},[_vm._v("Sign in with google!")]),_c('label',[_vm._v(_vm._s(_vm.resultmsg))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }